<template>
  <div class="row">
    <IconSelectorModal
      v-if="modalIsVisible"
      @select="(value) => form.icon_name = value"
      @close="modalIsVisible = false"
    />
    <div class="col-lg-12">
      <div class="col-lg-6">
        <div class="form__preview">
          <div class="preview__label">
            <label>Предварительный просмотр</label>
            <div v-if="withActions" class="label__actions">
              <input
                type="color"
                class="actions__input_colorpicker"
                v-model="form.icon_background"
                list
              />
              <button
                type="button"
                class="actions__button"
                @click="modalIsVisible = true"
              >
                Иконка
              </button>
            </div>
          </div>
          <div class="preview__elem">
            <AchievementPreview :data="preparingPreview" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AchievementPreview from "@/user/features/achievements/AchievementPreview";
import IconSelectorModal from "@/user/features/achievements/IconSelectorModal";
export default {
  props: {
    form: {
      type: Object,
      required: true,
    },
    withActions: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    AchievementPreview,
    IconSelectorModal,
  },
  data() {
    return {
      modalIsVisible: false,
    };
  },
  computed: {
    preparingPreview() {
      return {
        date_of_receiving: new Date(),
        achievement_id: {
          icon_background: this.form.icon_background,
          icon_name: this.form.icon_name,
          name: this.form.name || 'Без названия',
          description: this.form.description,
        },
      };
    },
  },
};
</script>

<style scoped>
.form__preview {
  display: inline-flex;
  align-items: center;
  flex-direction: column;
}
.preview__label,
.label__actions {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
}
.preview__label > label {
  white-space: nowrap;
  margin-bottom: 0;
}
.actions__input_colorpicker {
  margin: 0 1em;
  background: transparent;
  border: 1px rgb(182, 182, 182) solid;
}
.actions__button {
  background: transparent;
  border: 1px rgb(182, 182, 182) solid;
}
.actions__input_colorpicker:hover,
.actions__button:hover {
  cursor: pointer;
  opacity: 0.5;
  transition: 0.3s;
}
.preview__elem {
  width: 100%;
  margin-top: 1em;
  display: inline-flex;
  justify-content: flex-start;
}
@media (max-width: 1023px) {
  .preview__label > label {
    white-space: initial;
  }
  .label__actions {
    margin-top: 0.6em;
    display: flex;
    width: 100%;
  }
  .preview__label {
    flex-direction: column;
  }
  .actions__input_colorpicker {
    margin-left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/user/widgets/achievements/GeneratedIcon.vue